import { FetchHelper } from "shared-ts-utils-fetch";
import { ServerEnvironmentInfo } from "shared-ts-server-environment";

export class SystemDao {
  private fetchHelper: FetchHelper;

  constructor() {
    this.fetchHelper = new FetchHelper({ basePath: "/api/system/" });
  }

  async ping(): Promise<string> {
    return await this.fetchHelper.get("ping").fetchAsText();
  }

  getBuildNumber = async (): Promise<string> => {
    return this.fetchHelper.get("get-build-number").fetchAsText();
  };

  getServerEnvironmentInfo = async (): Promise<ServerEnvironmentInfo> => {
    return await this.fetchHelper
      .get("get-server-environment")
      .fetchAsJson<ServerEnvironmentInfo>();
  };

  checkAuthentication = async (): Promise<boolean> => {
    try {
      const response = await this.fetchHelper
        .get("check-authentication")
        .fetchAsResponse();
      return Promise.resolve(response.ok);
    } catch (e) {
      return Promise.resolve(false);
    }
  };
}
